var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_426_3189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8525 7.55103C9.3325 7.55103 8.9205 8.00103 8.9205 8.55003C8.9205 9.09903 9.3405 9.54903 9.8525 9.54903C10.3735 9.54903 10.7855 9.09903 10.7855 8.55003C10.7855 8.00103 10.3735 7.55103 9.8525 7.55103ZM6.5155 7.55103C5.9945 7.55103 5.5835 8.00103 5.5835 8.55003C5.5835 9.09903 6.0035 9.54903 6.5155 9.54903C7.0365 9.54903 7.4485 9.09903 7.4485 8.55003C7.4575 8.00103 7.0365 7.55103 6.5155 7.55103Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_426_3189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.17041 0H16.1704V18H0.17041V0Z",
    fill: "#4C525B"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_426_3189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7674 11.754C10.7674 11.754 10.4374 11.367 10.1634 11.025C11.3614 10.692 11.8184 9.95403 11.8184 9.95403C11.4891 10.1698 11.1365 10.3479 10.7674 10.485C10.3415 10.6639 9.89666 10.7937 9.44141 10.872C8.65817 11.0139 7.85555 11.0108 7.07341 10.863C6.55241 10.764 6.10341 10.62 5.72941 10.476C5.50006 10.3893 5.27688 10.2871 5.06141 10.17C5.03441 10.152 5.00741 10.143 4.97941 10.125C4.96141 10.116 4.95241 10.107 4.94341 10.098C4.77841 10.008 4.68741 9.94503 4.68741 9.94503C4.68741 9.94503 5.12541 10.665 6.28741 11.007C6.01241 11.349 5.67441 11.754 5.67441 11.754C3.65441 11.691 2.88541 10.386 2.88541 10.386C2.88541 7.48803 4.20241 5.13903 4.20241 5.13903C5.51941 4.16703 6.77241 4.19403 6.77241 4.19403L6.86241 4.30203C5.21741 4.77003 4.45841 5.48103 4.45841 5.48103C4.45841 5.48103 4.65941 5.37303 4.99841 5.22003C5.97641 4.79703 6.75341 4.68003 7.07341 4.65303C7.12841 4.64403 7.17341 4.63503 7.22841 4.63503C8.81233 4.42252 10.4228 4.71877 11.8274 5.48103C11.8274 5.48103 11.1054 4.80603 9.55141 4.33803L9.67941 4.19403C9.67941 4.19403 10.9314 4.16703 12.2484 5.13903C12.2484 5.13903 13.5644 7.48903 13.5644 10.386C13.5644 10.386 12.7874 11.691 10.7674 11.754ZM14.2964 2.69698e-05H2.04441C1.79963 -0.00128978 1.55698 0.0456212 1.33032 0.138081C1.10367 0.230542 0.897444 0.36674 0.723426 0.538901C0.549409 0.711061 0.411005 0.915812 0.316118 1.14146C0.221232 1.36711 0.17172 1.60924 0.17041 1.85403L0.17041 14.022C0.17041 15.048 1.01141 15.876 2.04441 15.876H12.4124L11.9284 14.211L13.0984 15.282L14.2044 16.29L16.1704 18V1.85403C16.1691 1.60924 16.1196 1.36711 16.0247 1.14146C15.9298 0.915812 15.7914 0.711061 15.6174 0.538901C15.4434 0.36674 15.2372 0.230542 15.0105 0.138081C14.7838 0.0456212 14.5412 -0.00128978 14.2964 2.69698e-05Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_3189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(0.17041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.4c30f51825fd928be7ead2d97e8cabeb.svg";
export { ForwardRef as ReactComponent };